import React from "react";

const FB = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <defs/>
      <path d="M19.322 18.255c0 .59-.478 1.067-1.067 1.067h-4.923V11.84h2.511l.376-2.915h-2.887V7.062c0-.845.234-1.42 1.445-1.42h1.544V3.033a20.74 20.74 0 00-2.25-.115c-2.226 0-3.75 1.36-3.75 3.855v2.15H7.803v2.916h2.518v7.483H1.066A1.067 1.067 0 010 18.255V1.067C0 .477.477 0 1.066 0h17.19c.588 0 1.066.477 1.066 1.067v17.188"/>
    </svg>
  );
};

export default FB;
